module.exports = __webpack_public_path__ + "img/svip3.acd39bf0.png";